import { render, staticRenderFns } from "./ProfitLossReport.vue?vue&type=template&id=b171e984&"
import script from "./ProfitLossReport.vue?vue&type=script&lang=js&"
export * from "./ProfitLossReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b171e984')) {
      api.createRecord('b171e984', component.options)
    } else {
      api.reload('b171e984', component.options)
    }
    module.hot.accept("./ProfitLossReport.vue?vue&type=template&id=b171e984&", function () {
      api.rerender('b171e984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/ProfitLossReport.vue"
export default component.exports